import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
  import BaseText from '@ui/atoms/baseText/BaseText.vue';
  import CodeInput from '@/components/screens/ScreenCodeInput.vue';
  import { apiGenerateScreenCode, apiConnectToScreenWithCode } from '@/api/screens';
  import { useToasted } from '@/helpers';
  import { AxiosError } from 'axios';
  import { ScreenCodeConnect } from '@/types/api/screens';

  
  const __default__ = {
    name: 'ScreenCodeTabs',
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    screenId: { type: Number, required: true }
  },
  emits: ["tab:tabChange"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'tab:tabChange', tab: Boolean): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    screenId: number;
  };

  

  const toasted = useToasted();
  const generatedCode = ref<string>('------');
  const codeGenerated = ref<Boolean>(false);
  const activateCode = ref<string>('');
  const isGenerateTab = ref<Boolean>(true);
  const codeSize = ref<number>(6);

  

  watch(isGenerateTab, (value) => {
    emit('tab:tabChange', value);
  });

  function setGenerateTab(generateTab: Boolean) {
    isGenerateTab.value = generateTab;
  }
  function setInputCode(code: string) {
    activateCode.value = code;
  }
  async function actionClicked() {
    try {
      if (isGenerateTab.value) {
        const response = await apiGenerateScreenCode(props.screenId);
        generatedCode.value = response.data.code as string;
        codeGenerated.value = true;
        return true;
      }
      if (activateCode.value.length !== codeSize.value) {
        toasted.global.general_error({
          message: 'Incomplete screen code',
        });
        return false;
      }
      const res = await apiConnectToScreenWithCode(props.screenId, activateCode.value);
      toasted.global.general_success({
        message: (res.data as ScreenCodeConnect).message,
      });
      return true;
    } catch (error) {
      console.log('code generation:', error);
      toasted.global.general_error({
        message: (error as AxiosError)?.response?.data?.message ?? String(error),
      });
      return false;
    }
  }

  expose({
    actionClicked,
  });

return { __sfc: true,props, toasted, generatedCode, codeGenerated, activateCode, isGenerateTab, codeSize, emit, setGenerateTab, setInputCode, actionClicked, BaseText, CodeInput }
}

})